import DevIcon from 'devicon-react-svg';
import styled from 'styled-components';
import { trioUITheme } from '@/styles/theme';

export const TechStackIcon = styled(DevIcon)`
  width: 24px;
  height: 24px;
  fill: ${trioUITheme.colors['neutral-90']};
`;
